import { useEffect } from 'react';
import { useSearchAssetsContext } from './SearchAssetsProvider';

export const CLEAR_SEARCH_FILTERS_EVENT = 'clearSearchFilters';

export const dispatchClearSearchFiltersEvent = () => {
  window.dispatchEvent(new Event(CLEAR_SEARCH_FILTERS_EVENT));
};

export const useClearSearchFiltersEvent = ({
  handleClearFilters,
}: {
  handleClearFilters: () => void;
}) => {
  const handleClearSearchFilters = () => {
    handleClearFilters();
  };
  useEffect(() => {
    window.addEventListener(
      CLEAR_SEARCH_FILTERS_EVENT,
      handleClearSearchFilters,
    );

    return () => {
      window.removeEventListener(
        CLEAR_SEARCH_FILTERS_EVENT,
        handleClearSearchFilters,
      );
    };
  }, [handleClearFilters]);
};

export const SearchAssetsPageEventsHandler = () => {
  const { handleClearFilters } = useSearchAssetsContext();

  useClearSearchFiltersEvent({ handleClearFilters });

  return null;
};
